import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type ContactSalesCtaProps = CtaShellProps

export function ContactSalesCta(props: ContactSalesCtaProps) {
  return <CtaShell {...props} layout="split" actionType="sales" primaryCta={props.primaryCta ?? { label: "Contact sales", href: "#sales" }} secondaryCta={props.secondaryCta ?? { label: "View security", href: "#security" }} socialProof={props.socialProof ?? { logos: [{ name: "SOC 2" }, { name: "GDPR" }, { name: "Enterprise SSO" }], quote: { body: "The fastest path from requirements to a site leadership could approve.", name: "Enterprise operator" } }} />
}
